import { Link } from "react-router-dom"
import Gallery from "../../elements/Gallery"

export default function Footer1() {
	return (
		<>
			<footer
				className="footer-section bg-cover bg-cover"
				style={{ backgroundImage: 'url("assets/img/footer/bg.jpg")' }}
			>
				<div className="container">
					<div className="contact-info-area">
						<Link
							to="/"
							className="logo-img wow fadeInUp"
							data-wow-delay=".2s"
						>
							<img src="assets/img/logo/Vmake_logo.svg" alt="img" width="130" height="100" />

						</Link>
						<div
							className="contact-info-items wow fadeInUp"
							data-wow-delay=".4s"
						>
							{/* <div className="icon">
								<i className="fa-sharp fa-solid fa-location-dot" />
							</div> */}
							<div className="content">
								<p>Office location</p>
								<h3>
									<a href="https://www.google.com/maps/place/VEER+PANEL+DOORS+%7C+VMAKE+DOORS/@12.8875336,77.6529803,14z/data=!4m6!3m5!1s0x3bae1378f3513c25:0x1a3d8c225ff13762!8m2!3d12.8819696!4d77.6742133!16s%2Fg%2F11hzht73zk?entry=ttu&g_ep=EgoyMDI1MDUyMS4wIKXMDSoJLDEwMjExNDUzSAFQAw%3D%3D" target="_blank" rel="noopener noreferrer">
										No. 447/2, Sy No.26/4B1 , N.H.7 ,<br /> Balagaranahalli Village Hosur Road,<br /> Near By  Nayara Petrol Pump, Attibele Post, <br /> Bengaluru Urban, Bengaluru-562107, Karnataka, India
									</a>
								</h3>
							</div>
						</div>
						<div
							className="contact-info-items wow fadeInUp"
							data-wow-delay=".6s"
						>
							<div className="icon">
								<i className="fa-solid fa-envelope" />
							</div>
							<div className="content">
								<p>send email</p>
								<h3>
									<a href="mailto:info@vmakewpc.com">info@vmakewpc.com</a>
								</h3>
							</div>
						</div>
						<div
							className="contact-info-items wow fadeInUp"
							data-wow-delay=".8s"
						>
							<div className="icon">
								<i className="fa-solid fa-phone-volume" />
							</div>
							<div className="content">
								<p>call us</p>
								<h3>
									<a href="tel:+917022565599">+91 7022565599</a>{" "}
								</h3>
							</div>
						</div>
					</div>
					<div className="footer-widgets-wrapper">
						<div className="row">
							<div
								className="col-xl-4 col-lg-4 col-md-6 wow fadeInUp"
								data-wow-delay=".2s"
							>
								<div className="single-footer-widget">
									<div className="widget-head">
										<h5>About Company</h5>
									</div>
									<div className="footer-content">
										<p>
											V-Make crafts premium WPC doors and <br />  frames with German technology, delivering <br /> durable and sustainable solutions trusted <br /> across the world.
										</p>

										<div className="social-icon d-flex align-items-center">
											<Link to="/#">
												<i className="fab fa-facebook-f" />
											</Link>
											<Link to="/#">
												<i className="fab fa-twitter" />
											</Link>
											<Link to="/#">
												<i className="fab fa-youtube" />
											</Link>
											<Link to="/#">
												<i className="fab fa-linkedin-in" />
											</Link>
										</div>
									</div>
								</div>
							</div>
							<div
								className="col-xl-2 col-lg-4 col-md-6 wow fadeInUp"
								data-wow-delay=".4s"
							>
								<div className="single-footer-widget">
									<div className="widget-head">
										<h5>Quick Link</h5>
									</div>
									<ul className="list-area">
										<li>
											<Link to="/">
												<i className="fa-solid fa-chevrons-right" />
												Home
											</Link>
										</li>
										<li>
											<Link to="/about">
												<i className="fa-solid fa-chevrons-right" />
												About Us
											</Link>
										</li>
										<li>
											<Link to="/blogs">
												<i className="fa-solid fa-chevrons-right" />
												Blogs
											</Link>
										</li>
										<li>
											<Link to="/contact">
												<i className="fa-solid fa-chevrons-right" />
												Contact Us
											</Link>
										</li>
									</ul>
								</div>
							</div>
							<div
								className="col-xl-3 col-lg-4 col-md-6 ps-lg-5 wow fadeInUp"
								data-wow-delay=".6s"
							>
								<div className="single-footer-widget">
									<div className="widget-head">
										<h5>Our Products</h5>
									</div>
									<ul className="list-area">
										<li>
											<Link to="/Wpc-Doors">
												<i className="fa-solid fa-chevrons-right" />
												Wpc Doors
											</Link>
										</li>
										<li>
											<Link to="/Wpc-Door-Frames">
												<i className="fa-solid fa-chevrons-right" />
												Wpc Door Frames
											</Link>
										</li>
										<li>
											<Link to="/Wpc-Foam-Board">
												<i className="fa-solid fa-chevrons-right" />
												Wpc Foam Board
											</Link>
										</li>
										<li>
											<Link to="/Wpc-UV-Digital-Series">
												<i className="fa-solid fa-chevrons-right" />
												Wpc UV Digital Series
											</Link>
										</li>

									</ul>
								</div>
							</div>
							{/* <div
								className="col-xl-3 col-lg-4 col-md-6 ps-lg-5 wow fadeInUp"
								data-wow-delay=".8s"
							>
								<div className="single-footer-widget">
									<div className="widget-head">
										<h5>Instagram</h5>
									</div>
									<div className="footer-gallery">
										<div className="gallery-wrap">
											<Gallery />
											<div className="">
												<div className="thumb">
													<Link
														to="https://www.instagram.com/p/DKeQk3wy8WW/?utm_source=ig_web_copy_link"
														className="img-popup"
													>
														<img
															src="assets/img/footer/img_1.png"
															alt="gallery-img"
															width="80"
															height="80"
														/>
														<div className="icon">
															<i className="far fa-plus" />
														</div>
													</Link>
												</div>
												<div className="thumb">
													<Link
														to="/assets/img/footer/gallery-5.jpg"
														className="img-popup"
													>
														<img
															src="assets/img/footer/gallery-5.jpg"
															alt="gallery-img"
														/>
														<div className="icon">
															<i className="far fa-plus" />
														</div>
													</Link>
												</div>
												<div className="thumb">
													<Link
														to="/assets/img/footer/gallery-6.jpg"
														className="img-popup"
													>
														<img
															src="assets/img/footer/gallery-6.jpg"
															alt="gallery-img"
														/>
														<div className="icon">
															<i className="far fa-plus" />
														</div>
													</Link>
												</div>
											</div>
										</div>
									</div>
								</div> */}
							{/* </div> */}
						</div>
					</div>
					<div className="footer-bottom" style={{ textAlign: 'left' }}>
						<p>
							© 2025 V-Make Industries. All Rights Reserved.
						</p>
					</div>
				</div>
			</footer>
		</>
	)
}
